



































































import {Component, Vue} from 'vue-property-decorator'
import ListSorter from "@/components/ListSorter/ListSorter.vue";
import MenuOptionSelector from "@/components/OptionSelector/MenuOptionSelector.vue";
import ItemOptionSelector from "@/components/OptionSelector/ItemOptionSelector.vue";
import CategoryItemsStore from "@/_common/api/store/modules/CategoryItemsStore";
import DeliousItemsStore from "@/_common/api/store/modules/DeliousItemsStore";
import Toggle from "@/components/UI/Toggle.vue";

@Component({
    components: {
        Toggle,
        ListSorter,
        MenuOptionSelector,
        ItemOptionSelector,
    },
})

export default class CategoryItemListSorter extends Vue {

    private headerFixPositionY!:number;

    get categoryId(): number {
        return Number(this.$route.params.categoryId);
    }

    get categoryItemIds(): number[] {
        const categoryItems: CMS.CategoryItem[] = CategoryItemsStore.categoryItemsByCategoryId[this.categoryId] || [];
        return categoryItems.map(v => v.id);
    }

    private mounted():void {
        this.fixPanelHeader();
    }

    private destroyed():void {
        window.removeEventListener('scroll', this.onScroll);
    }

    private toItemIds(categoryItemIds: number[]): number[] {
        return categoryItemIds.map(v => CategoryItemsStore.categoryItemById[v].item_id);
    }

    private toItemId(categoryItemId: number): number {
        return CategoryItemsStore.categoryItemById[categoryItemId].item_id;
    }

    private item(itemId: number): Delious.ItemBase {
        return DeliousItemsStore.itemById[itemId] || {};
    }

    private categoryItem(categoryItemId: number): CMS.CategoryItem {
        return CategoryItemsStore.categoryItemById[categoryItemId];
    }

    private fixPanelHeader(): void {
        let header:any = document.querySelector(".panel-header");
        let rect:any = header.getBoundingClientRect();
        let scrollTop:number = window.pageYOffset || document.documentElement.scrollTop;

        this.headerFixPositionY = rect.top + scrollTop - 148 - 10;

        window.addEventListener("scroll", this.onScroll);
    }

    private onScroll(): void {
        let windowScrollTop = document.documentElement.scrollTop || document.body.scrollTop;

        windowScrollTop > this.headerFixPositionY
            ? (<any>document).querySelector(".panel-header").classList.add('is-fixed')
            : (<any>document).querySelector(".panel-header").classList.remove('is-fixed');
    }
}

